import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { EventStoreListInterface } from 'app/modules/models/events-store-list';
import { AuthUtils } from 'app/core/auth/auth.utils';
import { FuseConfirmationConfig, FuseConfirmationService } from '@fuse/services/confirmation';
import { BehaviorSubject } from 'rxjs';

@Injectable({providedIn: 'root'})
export class UtilsService {

    private _shop_event_uuid:  BehaviorSubject<string> = new BehaviorSubject<string>('');

    constructor(
        private _route: Router,
        private _fuseDialog: FuseConfirmationService
    ) 
    { 
        
    }

    get shop_event_uuid() {
        return this._shop_event_uuid.getValue()
    }

    set shop_event_uuid(value: string) {
        this._shop_event_uuid.next(value)
    }

    get defaultEventimage() {
        return 'assets/images/event-placeholder-min.png'
    }
    /**
     * Redirect  to 404 error page
     */
    _404page() {
        this._route.navigateByUrl('/error')
    }
    

    /**
     * 
     * @param event 
     * @returns string placeholder image url if event image not exists
     */
    getEventImageSrc(event: EventStoreListInterface) {
        const url = event.img_url === 'S/D' ? this.defaultEventimage : event.img_url
        return url
    }




    /***
     * 
     */
    decodeToken(token: string) {
        return AuthUtils._decodeToken(token)
    }

    /**
     * 
     */
    openMessageDialog(title: string){
        const dialogConfig: FuseConfirmationConfig = {
            message:'',
            icon: {name: 'info', color: 'info'},
            title: title,
            actions: {
                confirm: {
                    label: 'Aceptar',
                    color: 'primary'
                },
                cancel: {
                    show: false
                }
            }
        }
        this._fuseDialog.open( dialogConfig)
    }



    getSeatLabel(seatObject: any, ...args: any[]): any {
        

        if(!seatObject) {
            return ''
        }

        const objectType = seatObject.objectType

        if (objectType === 'GeneralAdmissionArea') {
            return ''
        }

        if (objectType==='Seat') {
            const own = seatObject.labels.own
            const parent = seatObject.labels.parent
            const section  = seatObject.labels.section

            const parent_type = seatObject.parent.type && seatObject.parent.type == 'table' ? 'Mesa' : 'Fila'
            // return format label
            return  `${section} ${parent_type}  ${parent}  Silla ${own}`
        }
        else {
            return seatObject.id
        }

    }
}